import React, { useContext } from 'react';
import { DetailContext, DetailHandle } from '@eas/common-web';
import { EsFile } from '@models';
import { useCourtFilePermission } from '../../../es-file/es-file-permission';
import { DocumentFields as Documents } from '../../../es-file/fields/documents/documents';

export function DocumentFields() {
  const { source } = useContext<DetailHandle<EsFile>>(DetailContext);

  const { hasPermission } = useCourtFilePermission(source.data);

  return (
    <>
      <Documents hasPermission={hasPermission} />
    </>
  );
}
